import { Component } from '@angular/core';

@Component({
  selector: 'app-index-reports',
  template: `
    <router-outlet />
  `,
  styleUrls: []
})
export class IndexReportsComponent {
  
}
